import { combineReducers, } from 'redux';

import app from './app';
import navigation from './navigation';
import vehicle from './vehicle';
import vehicleAward from './entities/vehicleAward';
import consumerReviewAndRating from './entities/consumerReviewAndRating';
import expertReviewAndRating from './entities/expertReviewAndRating';
import accountInfoData from './accountInfoData';
import errors from './errors';

export default combineReducers({
  app,
  navigation,
  vehicle,
  vehicleAward,
  consumerReviewAndRating,
  expertReviewAndRating,
  accountInfoData,
  errors,
});
